<template>
  <div :class="['menu', 'clearfix', stateOpen ? 'menu--open' : '']">
    <button type="button" name="menu" @click="setMenuState">
      <span></span>
      <span></span>
      <span></span>
    </button>

    <transition name="fadeIn">
      <nav v-if="stateOpen">
        <ul>
          <li @click="setMenuState">
            <router-link to="/">Jeu</router-link>
          </li>
          <li @click="setMenuState">
            <router-link to="/biographies">Personnages</router-link>
          </li>
          <li @click="setMenuState">
            <router-link to="/reglement">Règlement</router-link>
          </li>
          <li @click="setMenuState">
            <router-link to="/contact">Contact</router-link>
          </li>
        </ul>

        <socials></socials>
      </nav>
    </transition>
  </div>
</template>

<script>
  import Socials from '../socials/Socials';

  export default {
    name: 'menu',
    components: {
      Socials,
    },
    data() {
      return {
        stateOpen: false,
      };
    },
    methods: {
      setMenuState() {
        if (this.stateOpen) {
          this.stateOpen = false;
        } else {
          this.stateOpen = true;
        }
      },
    },
  };
</script>


<style lang="scss">
  .menu {
    position: relative;
    margin-top: 15px;

    @include mobile {
      margin-top: 5px;
    }

    &::before {
      position: absolute;
      z-index: 1;
      top: -10px;
      right: 0;
      bottom: -30px;
      left: -50px;
      background: $beige;
      opacity: 0;
      content: '';
      @include defaultTransition(.4);
    }

    button {
      position: relative;
      z-index: 2;
      display: block;
      width: 50px;
      height: 50px;
      background: $white;
      border: 1px solid $white;
      border-radius: 100%;
      cursor: pointer;
      outline: none;
      float: right;
      margin-right: 9px;
      margin-bottom: 15px;
      @include defaultTransition(.4);

      span {
        position: absolute;
        left: 50%;
        height: 2px;
        background: $blue;
        transform: translate(-50%, -50%);
        @include defaultTransition(.4);

        &:first-child {
          top: 35%;
          width: 55%;
        }

        &:nth-child(2) {
          top: 50%;
          width: 45%;
        }

        &:last-child {
          top: 65%;
          width: 35%;
        }
      }

      &:hover {
        background: $blue;

        span {
          background: $white;
        }
      }
    }

    nav {
      position: relative;
      z-index: 2;
      clear: both;
      margin-top: 10px;

      ul {
        margin-bottom: 30px;
      }

      li {
        text-align: right;
        margin-bottom: 10px;
        padding-right: 20px;

        a {
          text-decoration: none;
          color: $blue;
          @include fontSize(22);
          @include defaultTransition(.4);

          &:hover {
            color: $white;
          }
        }
      }
    }

    &.menu--open {
      &::before {
        opacity: 1;
      }

      button span {
        &:first-child {
          top: 50%;
          transform: translate(-50%, -50%) rotate(45deg);
        }

        &:nth-child(2) {
          opacity: 0;
        }

        &:last-child {
          top: 50%;
          width: 55%;
          transform: translate(-50%, -50%) rotate(-45deg);
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// Menu.vue?ef6c2fc2